export abstract class BaseStore<Snapshot> {
  protected listeners = new Set<() => void>();

  protected snapshot = {} as Snapshot;

  constructor() {
    this.load();
    this.takeSnapshot();
  }

  // eslint-disable-next-line class-methods-use-this
  load() {}

  addListener(listener: () => void) {
    this.listeners.add(listener);
  }

  removeListener(listener: () => void) {
    this.listeners.delete(listener);
  }

  getSnapshot() {
    return this.snapshot;
  }

  publish() {
    setTimeout(() => this.listeners.forEach(listener => listener()), 0);
  }

  // eslint-disable-next-line class-methods-use-this
  takeSnapshot() {
    throw new Error('Not implemented');
  }

  update() {
    this.takeSnapshot();
    this.publish();
  }
}
